export default __webpack_public_path__ + "static/media/RobotoMono-Medium.1929bc34.woff";